// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as GatsbyLink from "gatsby-link";
import * as TypographyJs from "../utils/typography.js";
import * as Bio$GatsbyStarterReasonBlog from "../components/bio.bs.js";
import * as Seo$GatsbyStarterReasonBlog from "../components/seo.bs.js";
import * as Layout$GatsbyStarterReasonBlog from "../components/layout.bs.js";

function rhythm(prim) {
  return TypographyJs.rhythm(prim);
}

function scale(prim) {
  return TypographyJs.scale(prim);
}

function BlogPost(Props) {
  var data = Props.data;
  var pageContext = Props.pageContext;
  var $$location = Props.location;
  var post = data.markdownRemark;
  var siteTitle = data.site.siteMetadata.title;
  // var previous = pageContext.previous;
  // var next = pageContext.next;
  var postDescription = post.frontmatter.description;
  var description = postDescription !== undefined ? Caml_option.valFromOption(postDescription) : post.excerpt;
  var postTag = post.frontmatter.topictag != undefined ? post.frontmatter.topictag + " — " : ""
  var postTitle = post.frontmatter.title;
  return React.createElement(Layout$GatsbyStarterReasonBlog.make, {
              location: $$location,
              title: siteTitle,
              children: null
            }, React.createElement(Seo$GatsbyStarterReasonBlog.make, {
                  description: description,
                  title: postTitle
                }), React.createElement("article", undefined, React.createElement("header", undefined, React.createElement("h1", {
                          style: {
                            marginTop: TypographyJs.rhythm(1.0),
                            fontFamily: "Inconsolata, monospace",
                            fontSize: "3em",
                            marginBottom: "0"
                          }
                        }, postTitle), React.createElement("p", {
                          style: {
                            display: "block",
                            fontSize: TypographyJs.scale(-0.2).fontSize,
                            lineHeight: TypographyJs.scale(-0.2).lineHeight,
                            marginBottom: TypographyJs.rhythm(1.0)
                          }
                        }, postTag + post.frontmatter.date)), React.createElement("section", {
                      dangerouslySetInnerHTML: {
                        __html: post.html
                      }
                    }), React.createElement("hr", {
                      style: {
                        marginBottom: TypographyJs.rhythm(1.0)
                      }
                    }), React.createElement("footer", undefined, React.createElement(Bio$GatsbyStarterReasonBlog.make, { }))));
}

BlogPost.displayName = "BlogPostTemplate";

var Link;

var SEO;

var make = BlogPost;

var $$default = BlogPost;

export {
  Link ,
  SEO ,
  rhythm ,
  scale ,
  make ,
  $$default ,
  $$default as default,

}
/*  Not a pure module */
